import { LinkButton, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useResponsiveButtonSize, useSecondaryButtonTheme } from '../../../../utils/hooks';
import { useApplicationContext } from '../../../ApplicationContext';
import { usePersistentState } from '../../../../utils/persistentState';
import { jsx as _jsx } from "react/jsx-runtime";
export var DefaultButtonCloseContainer = function DefaultButtonCloseContainer(props) {
  var _useApplicationContex = useApplicationContext(),
    layoutConfiguration = _useApplicationContex.layoutConfiguration;
  var _usePersistentState = usePersistentState(),
    isAvailable = _usePersistentState.isAvailable,
    save = _usePersistentState.save;
  var deviceType = useDeviceType();
  var size = useResponsiveButtonSize();
  var theme = useSecondaryButtonTheme();
  var isSaveAndCloseButton = props.saveEnabled && isAvailable() && layoutConfiguration.footer.closeButton.type === 'save_close';
  var text = isSaveAndCloseButton ? 'Сохранить и закрыть' : 'Закрыть';
  var handleClose = React.useCallback(function (e) {
    var href = e.currentTarget.href;
    e.preventDefault();
    if (isSaveAndCloseButton) {
      save();
    }

    // Логика с window top нужна для корректной работы в storybook.
    // Если компонент перестанет использоваться в storybook, то это можно
    // смело выпилить и оставить window.location.href = href;
    if (!window.top) {
      window.location.href = href;
      return;
    }
    try {
      window.top.location.href = href;
    } catch (ex) {
      window.location.href = href;
    }
  }, [isSaveAndCloseButton, save]);
  return /*#__PURE__*/_jsx(LinkButton, {
    href: "/",
    fullWidth: deviceType === 'phone',
    theme: props.theme || theme,
    size: size,
    onClick: handleClose,
    children: props.text || text
  });
};